<template>
  <div v-if="clcId != 'count'">
      <div class="lms-grading-student-list-home__course-header">
        <span class="lms-grading-student-list-home__clc">
          {{ clcData.clc.name }}
          <div class="lms-grading-student-list-home__clc-sub-row">
            <div class="lms-grading-student-list-home__clc-sub-inner">
              <span v-t="'home.facilitatorGrading.ungraded-tasks'"></span> {{ clcNotGraded(clcData.clc) }}
            </div>
            <div class="lms-grading-student-list-home__clc-sub-inner">
              <span v-t="'home.facilitatorGrading.graded-unpublished'"></span> {{ clcNotPublished(clcData.clc) }}
            </div>
          </div>
        </span>
        <div class="lms-grading-student-list-home__course-toogle" @click="toggleOpen">
          <jwl-toggle :is-open="open" />
        </div>
      </div>
      <div class="lms-grading-student-list-home__course-content" v-if="open">
        <div
          class="lms-grading-student-list-home__student-list-item"
          :class="getStudentClasses(student)"
          v-for="student in clcData.students"
          :key="student.jwlId">
          <router-link
            class="lms-grading-student-list-home__link"
            :to="selectListItem(student.id)">
            <div class="lms-grading-student-list-home__student-list-item-name">{{ student.displayName }}</div>
            <div class="lms-grading-student-list-home__student-list-item-id">ID: {{ student.jwlId }}</div>
          </router-link>
          <router-link
            class="lms-grading-student-list-home__link"
            :to="selectListItem(student.id, 'notGraded')">
            <div class="jwl-facilitator-grading-overview__row--sub">
              <div class="jwl-facilitator-grading-overview__sub--headline">
                <h5 v-t="'home.facilitatorGrading.ungraded-tasks'" /> {{ notGraded(student) }}
              </div>
            </div>
          </router-link>
          <router-link
            class="lms-grading-student-list-home__link"
            :to="selectListItem(student.id, 'gradedUnpublished')">
            <div class="jwl-facilitator-grading-overview__row--sub">
              <div class="jwl-facilitator-grading-overview__sub--headline">
                <h5 v-t="'home.facilitatorGrading.graded-unpublished'" /> {{ notPublished(student) }}
              </div>
            </div>
          </router-link>
          <router-link
            class="lms-grading-student-list-home__student_link"
            :to="selectListItem(student.id)">
            <div class="jwl-facilitator-grading-overview__row--sub">
               <span v-t="'home.facilitatorGrading.grade-student'" />
            </div>
          </router-link>
        </div>
      </div>
      <div class="lms-grading-student-list-home__course-content-bottom mt-5" v-if="open">
        <jwl-button class="lms-grading-student-list-home__student-all-link jwl-button" :to-route="selectAllItems" :normal-button-style="true">
          <span v-t="'home.facilitatorGrading.grade-all'" />
        </jwl-button>
      </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    classroomId: Number,
    selectedClassroom: Object,
    courseCode: String,
    clcData: Object,
    clcsAndGradableStudents: Object,
    clcId: String,
  });

  const open = ref(false);
  const loadingState = ref(0);

  const selectListItem = (jwlId, status) => {
    return {
      name: 'facilitator_grading_students',
      params: {
        classroomId: props.classroomId.toString(),
        course: props.courseCode,
        studentJwlId: jwlId,
      },
      query: {
        filterByStudent: jwlId,
        filterByStatus: status,
        filterByClc: props.clcId,
      },
    };
  };

  const selectAllItems = computed(() => {
    return {
      name: 'facilitator_grading_students',
      params: {
        classroomId: props.classroomId.toString(),
        course: props.courseCode,
        studentJwlId: 'all',
      },
      query: {
        filterByStudent: 'all',
        filterByClc: props.clcId,
      },
    };
  });

  const notPublished = (student) => {
    if (props.clcsAndGradableStudents.count[student.id]?.countGradeNotPublished) {
      return props.clcsAndGradableStudents.count[student.id].countGradeNotPublished;
    }
    return 0;
  };

  const notGraded = (student) => {
    if (props.clcsAndGradableStudents.count[student.id]?.countNotGraded) {
      return props.clcsAndGradableStudents.count[student.id].countNotGraded;
    }
    return 0;
  };

  const clcNotPublished = (clc) => {
    if (clc?.countGradeNotPublished) {
      return clc.countGradeNotPublished;
    }
    return 0;
  };

  const clcNotGraded = (clc) => {
    if (clc?.countNotGraded) {
      return clc.countNotGraded;
    }
    return 0;
  };

  const toggleOpen = () => {
    open.value = !open.value;
    if (open && loadingState === 0) {
      // this.loadData();
    }
  };

  const getStudentClasses = (item) => `countNotGraded-${notGraded(item)} countGradeNotPublished-${notPublished(item)}`;
</script>

<style lang="scss">
.lms-grading-student-list-home{
  &__course-header{
    align-items: flex-start;
    background-color: var(--color-gray-100);
    color: var(--color-gray-800);
    border-radius: 3px;
    box-sizing: border-box;
    display: grid;
    grid-template:
        "title toggle" auto
        "meta toggle" auto/auto 4rem;
    padding: 1rem 1.5rem;
    width: 100%;
  }
  &__course-toogle{
    --toggle-color: var(--color-gray-800);

    align-items: center;
    display: flex;
    grid-area: toggle;
    height: 100%;
    justify-content: center;
  }
  &__course-content{
    align-items: flex-start;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 0.5rem;
  }
  &__course-content-bottom{
    display: flex;
    justify-content: flex-end;
  }
  &__student-list-item{
    padding: 1rem 0;
    &.countNotGraded-0.countGradeNotPublished-0{
      display: none;
    }
  }

  &__student_link {
    color: var(--color-blue);
    text-decoration: underline;
    .jwl-facilitator-grading-overview__row--sub{
      padding-top: .5rem;
    }
  }

  &__student-all-link{
    --primary-color: var(--color-blue);
    --border-color: var(--color-blue);
  }

  .jwl-toggle{
    --toggle-color: var(--color-gray-800);
  }
  &__clc-sub-row{
    margin-top: 1rem;
    display: flex;
  }
  &__clc-sub-inner{
    display: flex;
    margin-right: 1rem;
    font-size: .8rem;
  }

  &__student-list-item-id{
    color: #585858;
    font-size: 0.85rem;
    margin: 0 0 1rem;
    padding: 0 0;
  }
}
</style>
